export const Types = {
  STORE_IS_MODAL_OPEN: 'presentation/store_is_modal_open'
}

export class StoreIsModalOpen implements FluxStandardAction {
  type = Types.STORE_IS_MODAL_OPEN
  constructor(public payload: boolean) {}
}
